"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.complianceJiraWebhookPermissions = void 0;
var enum_1 = require("../enum");
exports.complianceJiraWebhookPermissions = [
    enum_1.Permissions.CanIgnoreCustomGrants,
];
